<template>
  <a-swiper
    :swipe-list="qirGallery"
    :custom-options="swiperOptions"
    :display-arrows="false"
    :pagination="true"
    :swiper-pagination-custom-class="$options.consts.SWIPER_PAGINATION_CLASS"
    class="qir-overview-slider__wrapper"
  >
    <a-image
      slot-scope="{ slide }"
      :image="slide.Image"
      :url="slide.Link"
      :open-in-new-tab="true"
      class="qir-overview-slider__slide-wrapper"
    />

    <div
      slot="bullets"
      class="swiper-pagination swiper-pagination-bullets"
      :class="$options.consts.SWIPER_PAGINATION_CLASS"
    />
  </a-swiper>
</template>

<script>
import ASwiper from 'shared/ASwiper/index.vue'
import { PROP_TYPES, propValidator } from '@fmpedia/validators'

const SWIPER_PAGINATION_CLASS =
  'qir-overview-slider__swiper-pagination-container'

export default {
  name: 'QirOverviewSlider',
  components: { ASwiper },
  props: {
    qirGallery: propValidator([PROP_TYPES.ARRAY])
  },
  consts: {
    SWIPER_PAGINATION_CLASS
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 0,
        pagination: false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.qir-overview-slider__wrapper {
  @include mobile {
    margin-right: -#{$padding-x-mobile};
  }

  /deep/ .swiper__custom-swiper {
    margin: 0;
  }

  .qir-overview-slider__slide-wrapper,
  /deep/ .swiper__list__item {
    $width: (
      $above-desktop-xl: 500px
    );

    $height: (
      $above-desktop-xl: 400px
    );

    @include setStyleByBreakpoint('height', $height);
    @include setStyleByBreakpoint('width', $width);
  }

  /deep/ .a-image__link {
    display: flex;
    height: 100%;
  }

  /deep/ .swiper__custom-swiper {
    width: 100%;
  }
}
</style>
